export default __webpack_public_path__ + "static/media/mocked-social-item.9a567a28.png";